import { render, staticRenderFns } from "./ScheduleRegister.vue?vue&type=template&id=70c4d5e7"
import script from "./ScheduleRegister.vue?vue&type=script&lang=js"
export * from "./ScheduleRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70c4d5e7')) {
      api.createRecord('70c4d5e7', component.options)
    } else {
      api.reload('70c4d5e7', component.options)
    }
    module.hot.accept("./ScheduleRegister.vue?vue&type=template&id=70c4d5e7", function () {
      api.rerender('70c4d5e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/integration/ScheduleRegister.vue"
export default component.exports